/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
/**
 * Libraries
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Consginment details
 */
import { ConsignmentDetailRoutingModule } from './consignment-detail.routing.module';
import { ConsignmentDetailComponent } from './consignment-detail.component';

/**
 * External Modules
 */
import { HeaderModule } from '../../shared/header/header.module';
import { FooterModule } from '../../shared/footer/footer.module';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    ConsignmentDetailRoutingModule,
  ],
  declarations: [
    ConsignmentDetailComponent,
  ]
})
export class ConsignmentDetailModule { }
